import { TableCell, TableRow } from 'app/ui'

import * as styles from './index.css'

type TableRowTitleProperties = {
    label: string
    colSpan: number
}

export const TableRowTitle = ({
    label,
    colSpan,
}: Readonly<TableRowTitleProperties>): JSX.Element => {
    return (
        <TableRow>
            <TableCell
                className={styles.title}
                colSpan={colSpan}
            >
                {label}
            </TableCell>
        </TableRow>
    )
}
